import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TableSortLabel,
    Box,
    Tooltip,
    Button,
    Typography,
    Popper,
    Paper,
    Stack,
    FormControlLabel,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PdfViewImage from "../../assets/images/Pdf-view.png";
import Styles from "../../sharedComponents/MaterCommonTable/MasterCommonTable.module.scss";
import { visuallyHidden } from "@mui/utils";
import CommonLoader from "../../sharedComponents/CommonLoader/CommonLoader";
// Import additional icons
import BugReportIcon from '../../assets/images/bug.png';
import TaskIcon from '../../assets/images/task.png';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import VerifiedIcon from '@mui/icons-material/Verified';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ConfirmDelete_Icon from "../../assets/images/CommonTableImg/ConfirmDelete_Icon.svg";
import Right_Icon from "../../assets/images/Right_Icon.svg";
import Wrong_Icon from "../../assets/images/Wrong_Icon.svg";
import Three_Dot from "../../assets/images/CommonTableImg/Three_Dots.svg";

import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import EmptyData_Image from "../../assets/images/CommonTableImg/EmptyData_Icon.svg";
import moment from "moment";

import {
    Dialog,
    ClickAwayListener,
} from "@mui/material";

const LeaveSummaryTable = ({
    columns,
    data,
    handleEdit,
    handleView,
    handleToggle,
    handleApprove,
    handleRevert,
    handleRevertToWaiting,
    handleReject,
    handleDelete,
    handleHistory,
    handleAvailable,
    tableConfig,
    tableActionButton,
    openLoader,
    tableTotalCount = 0,
    isServerSide = false,
    maxSetHeight = false,
    tableOutputEvent = () => { },
    groupedHeaders, // New Prop for 2-row headers
    handleEarnedCreditClick
}) => {
    const [order, setOrder] = React.useState("");
    const [orderBy, setOrderBy] = React.useState("");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [sortedData, setSortedData] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedRow, setSelectedRow] = React.useState(null);

    useEffect(() => {
        if (!isServerSide) {
            const sorted = stableSort(data, getComparator(order, orderBy));
            setSortedData(sorted);
        } else {
            setSortedData(data);
            if (data?.length === 0 && tableTotalCount) {
                setPage((prev) => (prev > 0 ? prev - 1 : 0));
                if (page >= 0) {
                    tableOutputEvent({
                        page: page || 1,
                        limit: rowsPerPage,
                        sortType: order,
                        sort: order === "desc" ? `-${orderBy}` : orderBy,
                    });
                }
            }
        }
    }, [data, order, orderBy, isServerSide]);

    const [isOptionsVisible, setIsOptionsVisible] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);

    const toggleOptionsVisibility = (event, row) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setIsOptionsVisible((prev) => !prev);
        setSelectedRow(row);
    };

    const closeOptions = () => {
        setIsOptionsVisible(false);
        setAnchorEl(null);
    };

    const IOSSwitch = styled((props) => (
        <Switch
            focusVisibleClassName=".Mui-focusVisible"
            disableRipple
            {...props}
        />
    ))(({ theme }) => ({
        width: 35,
        height: 17,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: "0px",
            margin: 1,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(18px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#008080",
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles("dark", {
                        backgroundColor: "#2ECA45",
                    }),
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.grey[100],
                ...theme.applyStyles("dark", {
                    color: theme.palette.grey[600],
                }),
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.7,
                ...theme.applyStyles("dark", {
                    opacity: 0.3,
                }),
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 15,
            height: 15,
        },
        "& .MuiSwitch-track": {
            borderRadius: 25 / 2,
            backgroundColor: "#676767",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500,
            }),
            ...theme.applyStyles("dark", {
                backgroundColor: "#39393D",
            }),
        },
    }));

    const handleRequestSort = (event, property) => {
        setPage(0);
        const isAsc = orderBy === property && order === "asc";
        const orderType = isAsc ? "desc" : "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        if (isServerSide) {
            setSortedData(data);
            tableOutputEvent({
                page: 1,
                limit: rowsPerPage,
                sortType: orderType,
                sort: orderType === "desc" ? `-${property}` : property,
            });
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        if (isServerSide) {
            tableOutputEvent({
                page: newPage + 1,
                limit: rowsPerPage,
                sortType: order,
                sort: order === "desc" ? `-${orderBy}` : orderBy,
            });
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        if (isServerSide) {
            tableOutputEvent({
                page: 1,
                limit: parseInt(event.target.value, 10),
                sortType: order,
                sort: order === "desc" ? `-${orderBy}` : orderBy,
            });
        }
    };

    const stableSort = (array, comparator) => {
        if (!array || !Array.isArray(array)) {
            return [];
        }
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const getComparator = (order, orderBy) => {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const descendingComparator = (a, b, orderBy) => {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    };

    const RenderView = (value, columnId, row) => {
        if (value == null) return "---";

        if (Array.isArray(value)) {
            const joinedValues = value.filter(v => v != null).join(", ");
            return (
                <Typography className={Styles.TableBodyCell}>
                    {joinedValues || "---"}
                </Typography>
            );
        }

        switch (columnId) {
            case 'status':
                let statusIcon = null;
                let statusColor = '';
                switch (value) {
                    case 'To Do': statusIcon = <RadioButtonUncheckedIcon fontSize="small" />; statusColor = '#9CA3AF'; break;
                    case 'InProgress': statusIcon = <AutorenewIcon fontSize="small" />; statusColor = '#3B82F6'; break;
                    case 'QA': statusIcon = <VerifiedIcon fontSize="small" />; statusColor = '#8B5CF6'; break;
                    case 'Completed': statusIcon = <CheckCircleIcon fontSize="small" />; statusColor = '#10B981'; break;
                    case 'Production': statusIcon = <RocketLaunchIcon fontSize="small" />; statusColor = '#F59E0B'; break;
                    default: break;
                }
            case 'priority':
                let priorityColor = '';
                switch (value) {
                    case 'High': priorityColor = '#F30E0E'; break;
                    case 'Medium': priorityColor = '#1087EF'; break;
                    case 'Low': priorityColor = '#009735'; break;
                    default: break;
                }
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <span style={{ color: priorityColor }}>{value}</span>
                    </Box>
                );
            case 'taskType':
                let typeIcon = null;
                switch (value) {
                    case 'Bugs': typeIcon = <img src={BugReportIcon} style={{ width: "18px", height: "18px" }} alt="Bug" />; break;
                    case 'Task': typeIcon = <img src={TaskIcon} style={{ width: "18px", height: "18px" }} alt="Task" />; break;
                    default: break;
                }
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        {typeIcon}
                        <span>{value}</span>
                    </Box>
                );
            case 'deadlineDate':
            case 'deadLineDate':
                const isOverdue = moment(row.deadLineDate).isBefore(moment(), 'day');
                return (
                    <Tooltip title={isOverdue ? "Overdue task!" : ""} arrow>
                        <span style={{ color: isOverdue ? '#EF4444' : 'inherit' }}>
                            {moment(row?.deadLineDate).format("DD/MM/YYYY")}
                        </span>
                    </Tooltip>
                );
            case 'timeDifference':
                const isHighDifference = row.timeDifferenceMinutes > 15;
                return (
                    <Tooltip title={isHighDifference ? "Difference exceeds 15 minutes!" : ""} arrow>
                        <span style={{
                            color: isHighDifference ? '#EF4444' : '#10B981',
                            fontWeight: isHighDifference ? 'bold' : 'normal'
                        }}>
                            {value}
                        </span>
                    </Tooltip>
                );
            default:
                return (
                    <Typography className={Styles.TableBodyCell}>
                        {value}
                    </Typography>
                );
        }
    };

    return (
        <div className={Styles.renderingTable}>
            <TableContainer className={Styles.tableContainer}>
                {openLoader ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '400px',
                            width: '100%'
                        }}
                    >
                        <CircularProgress size={50} sx={{ color: '#008080' }} />
                    </Box>
                ) : (
                    <Box sx={{ height: "100%" }}>
                        <Box
                            sx={{ height: "100%" }}
                            className={`${maxSetHeight === true ? Styles.tableContent2 : Styles.tableContent} no-scrollbar`}
                        >
                            <Table stickyHeader className={sortedData?.length ? "" : "h-100"}>
                                <TableHead>
                                    {groupedHeaders ? (
                                        groupedHeaders.map((row, index) => (
                                            <TableRow key={index}>
                                                {row.map((cell, cellIndex) => {
                                                    // Determine if right border is needed
                                                    let showRightBorder = false;
                                                    // Top Row
                                                    if (index === 0) {
                                                        showRightBorder = true; // Always separate top-level groups
                                                    }
                                                    // Bottom Row (Indices 2 and 6 mark ends of groups)
                                                    else if (index === 1) {
                                                        if (cellIndex === 2 || cellIndex === 6) showRightBorder = true;
                                                    }

                                                    return (
                                                        <TableCell
                                                            key={cellIndex}
                                                            colSpan={cell.colSpan}
                                                            rowSpan={cell.rowSpan}
                                                            className={Styles.TableCell}
                                                            align={cell.align || "center"}
                                                            sx={{
                                                                zIndex: index === 0 ? 101 : 100,
                                                                borderRight: showRightBorder ? "1px solid #d5d7e8 !important" : "none",
                                                                borderBottom: "1px solid #d5d7e8 !important",
                                                                borderTop: index === 0 ? "1px solid #d5d7e8 !important" : "none",
                                                                borderLeft: cellIndex === 0 ? "1px solid #d5d7e8 !important" : "none",
                                                                backgroundColor: "#fafafa",
                                                                position: "sticky",
                                                                top: index === 0 ? 0 : 40, // Adjusted for smaller height
                                                                height: "40px !important", // Force smaller height
                                                                padding: "4px 8px !important", // Reduce padding
                                                                fontSize: "13px !important",
                                                                lineHeight: "1.2 !important"
                                                            }}
                                                        >
                                                            {cell.label}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    sortDirection={orderBy === column.id ? order : false}
                                                    className={Styles.TableCell}
                                                    align="left"
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === column.id}
                                                        direction={orderBy === column.id ? order : "asc"}
                                                        onClick={(e) => handleRequestSort(e, column.id)}
                                                    >
                                                        {column.label}
                                                        {orderBy === column.id ? (
                                                            <Box component="span" sx={visuallyHidden}>
                                                                {order === "desc" ? "sorted descending" : "sorted ascending"}
                                                            </Box>
                                                        ) : null}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                            {tableConfig.isAction ? (
                                                <TableCell className={Styles.TableCell} align="center">
                                                    Action
                                                </TableCell>
                                            ) : null}
                                        </TableRow>
                                    )}
                                </TableHead>
                                <TableBody>
                                    {sortedData?.length ? (
                                        (isServerSide
                                            ? sortedData
                                            : sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        ).map((row, index) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    key={index}
                                                    sx={{
                                                        backgroundColor: 'white',
                                                        '&:hover': {
                                                            backgroundColor: row.status === 'Completed' ? '#f0fff0' :
                                                                row.status === 'InProgress' ? '#f0f8ff' :
                                                                    row.status === 'QA' ? '#f5f0ff' : 'white'
                                                        }
                                                    }}
                                                >
                                                    {columns.map((column, colIndex) => {
                                                        const showRightBorder = colIndex === 0 || colIndex === 3 || colIndex === 7;

                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                className={Styles.TableBodyCell}
                                                                sx={{
                                                                    borderRight: showRightBorder ? '1px solid #d5d7e8 !important' : 'none'
                                                                }}
                                                            >
                                                                {RenderView(row[column.id], column.id, row)}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    {tableConfig.isAction ? (
                                                        <TableCell
                                                            className={Styles.TableBodyCell}
                                                            sx={{
                                                                borderLeft: '1px solid #d5d7e8 !important'
                                                            }}
                                                        >
                                                            <Box className={Styles.ActionContainer}>
                                                                <IconButton
                                                                    onClick={(e) => {
                                                                        setAnchorEl(e.currentTarget);
                                                                        setSelectedRow(row);
                                                                    }}
                                                                    sx={{ color: "#3D3D3D", "&:hover": { color: "#008080" } }}
                                                                    size="small"
                                                                >
                                                                    <MoreVertIcon fontSize="small" />
                                                                </IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    ) : null}
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={columns.length + (tableConfig.isAction ? 1 : 0)} align="center">
                                                <div className="d-flex flex-column w-100 justify-content-center align-items-center">
                                                    <img src={EmptyData_Image} alt="Empty Data Image" />
                                                    <Typography sx={{ m: 2, fontWeight: 700 }}>Oops, It's Empty Here!</Typography>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                        <Box className={Styles.PaginationContainer}>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={isServerSide ? tableTotalCount : data?.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Box>
                    </Box>
                )}
            </TableContainer>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => {
                    setAnchorEl(null);
                    setSelectedRow(null);
                }}
            >
                <MenuItem onClick={() => {
                    if (selectedRow && handleHistory) {
                        handleHistory(selectedRow);
                    }
                    setAnchorEl(null);
                    setSelectedRow(null);
                }}>
                    <ListItemIcon>
                        <HistoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Leave Apply History</ListItemText>
                </MenuItem>
                {handleEarnedCreditClick && (
                    <MenuItem onClick={() => {
                        if (selectedRow && handleEarnedCreditClick) {
                            handleEarnedCreditClick(selectedRow);
                        }
                        setAnchorEl(null);
                        setSelectedRow(null);
                    }}>
                        <ListItemIcon>
                            <MoreTimeIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Earned Leave Apply History</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
};

export default LeaveSummaryTable;
